import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Modal } from 'antd';
import ProductForm, { EMPTY_PRODUCT, ProductPayload } from './ProductForm';

export type EditProductPayload = ProductPayload;

type EditProductModalProps = {
  open: boolean;
  isSaving: boolean;
  categoryOptions: Array<{ value: string; label: string }>;
  initialValues: EditProductPayload | null;
  onCancel: () => void;
  onSubmit: (payload: EditProductPayload) => Promise<void>;
};

function EditProductModal({
  open,
  isSaving,
  categoryOptions,
  initialValues,
  onCancel,
  onSubmit,
}: EditProductModalProps) {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<ProductPayload>({
    defaultValues: { ...EMPTY_PRODUCT, subcategory: categoryOptions[0]?.value ?? '' },
  });

  useEffect(() => {
    if (!open) return;
    reset(initialValues ?? { ...EMPTY_PRODUCT, subcategory: categoryOptions[0]?.value ?? '' });
  }, [open, initialValues, categoryOptions, reset]);

  const handleOk = handleSubmit(async (values) => {
    await onSubmit(values);
  });

  const handleCancel = () => {
    reset();
    onCancel();
  };

  return (
    <Modal
      title="Редактировать товар"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Сохранить"
      cancelText="Отмена"
      confirmLoading={isSaving}
      destroyOnClose
      styles={{ body: { maxHeight: '65vh', overflowY: 'auto', overflowX: 'hidden', paddingRight: 4 } }}
    >
      <ProductForm control={control} errors={errors} categoryOptions={categoryOptions} setValue={setValue} />
    </Modal>
  );
}

export default EditProductModal;
